import React, { useState, useEffect } from 'react';
import './expandablesection.css';

const ExpandableSection = ({
  title,
  children,
  state = false,
  controlMap = null, // Optional control map
  panelLocation = '', // Optional panel location identifier
  numberOfItemsInLine = 3,
  sectionId = '', // Optional section ID for navigation
  onExpandChange = null, // Optional callback when expanded state changes
  forceExpanded = null // Optional: force expanded state from parent (true/false), null means use internal state
}) => {
  const [isExpanded, setIsExpanded] = useState(state);

  // Sync with forceExpanded prop when it changes
  useEffect(() => {
    if (forceExpanded !== null && forceExpanded !== isExpanded) {
      setIsExpanded(forceExpanded);
    }
  }, [forceExpanded]);

  const toggleExpand = () => {
    const newExpanded = !isExpanded;
    setIsExpanded(newExpanded);
    if (onExpandChange && sectionId) {
      onExpandChange(sectionId, newExpanded);
    }
  };

  return (
    <div id={`${title}`} className={`expandable-section panel-${panelLocation}`} data-section-id={sectionId}>
        <div className="section-header" onClick={toggleExpand}>
            <h2>{title}</h2>
            <span className="arrow">{isExpanded ? '▲' : '▼'}</span>
        </div>
        <div
            className="section-content"
            style={{ display: isExpanded ? 'block' : 'none' }} // Content remains mounted
        >
            {controlMap &&
                Object.values(
                    controlMap
                        .filter((control) => control.status === 'active')
                        .reduce((rows, control) => {
                            const rowIndex = control.position[0];
                            if (!rows[rowIndex]) rows[rowIndex] = [];
                            rows[rowIndex].push(control);
                            return rows;
                        }, {})
                ).map((rowControls, rowIndex) => (
                    <div key={`row-${rowIndex}`} className={`grid-container${numberOfItemsInLine} container-spacing`}>
                        {rowControls.map((control) => (
                            <div key={control.id} className="grid-item" style={{ gridColumn: control.position[1] }}>
                                {control.component}
                            </div>
                        ))}
                    </div>
                ))}
            {children}
        </div>
    </div>
);

};

export default ExpandableSection;
